import isPlainObj from"is-plain-obj";



















export const isObject=(value,classes)=>
classes?isWeakObject(value):isPlainObj(value);

export const isWeakObject=(value)=>{
const typeofValue=typeof value;
return(
(typeofValue==="object"||typeofValue==="function")&&value!==null)

};